import { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import api from "@/lib/api";
import { toast } from "sonner";
import { History } from "lucide-react";

const SECTION_LABELS = {
  rfc_policy: "RFC Policy",
  scorecard: "Scorecard",
  ltv_matrix: "LTV / ROI Matrix",
  exception_matrix: "Exception Matrix",
  partner_policy: "Partner Rules",
};

export default function PolicyAuditTab() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/policy/audit").then(r => setItems(r.data)).catch(() => toast.error("Could not load audit log"));
  }, []);

  const fmt = (v) => {
    if (v === null || v === undefined) return "—";
    if (typeof v === "object") return JSON.stringify(v);
    return String(v);
  };

  return (
    <Card className="p-5 border-slate-200" data-testid="policy-audit-tab">
      <div className="text-sm font-semibold text-slate-900 mb-3 flex items-center gap-2"><History size={16} /> Policy change audit log</div>
      {items.length === 0 ? (
        <div className="text-sm text-slate-500">No policy changes recorded yet.</div>
      ) : (
        <div className="space-y-2">
          {items.map(entry => (
            <div key={entry.id} className="border border-slate-100 rounded-md p-3 text-sm" data-testid={`policy-audit-row-${entry.id}`}>
              <div className="flex flex-wrap justify-between gap-2">
                <div className="font-medium text-slate-900">
                  {SECTION_LABELS[entry.section] || entry.section}
                  <span className="ml-2 text-xs font-mono text-slate-500">v{entry.version}</span>
                </div>
                <div className="text-xs text-slate-500">{String(entry.at).slice(0, 19).replace("T", " ")} · {entry.by_name} ({entry.by_role})</div>
              </div>
              <div className="mt-1.5 space-y-0.5">
                {(entry.changes || []).map((c, i) => (
                  <div key={i} className="text-xs font-mono text-slate-600">
                    <span className="text-slate-900">{c.field}</span>: {fmt(c.old)} → <span className="text-teal-700">{fmt(c.new)}</span>
                  </div>
                ))}
              </div>
              {entry.reason && <div className="text-xs text-slate-500 mt-1.5 italic">Reason: {entry.reason}</div>}
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
